var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#389C67",
    stroke: "#389C67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9001 13.4345L15.0497 9.24922C15.2091 9.0896 15.4247 9 15.6494 9C15.8741 9 16.0897 9.0896 16.249 9.24922C16.3287 9.3289 16.392 9.42369 16.4352 9.52812C16.4784 9.63256 16.5006 9.74458 16.5006 9.85772C16.5006 9.97086 16.4784 10.0829 16.4352 10.1873C16.392 10.2918 16.3287 10.3866 16.249 10.4662L11.4955 15.2515C11.337 15.4098 11.1232 15.4991 10.9001 15.5C10.7881 15.5007 10.6772 15.479 10.5735 15.4364C10.4699 15.3937 10.3756 15.3309 10.2962 15.2515L8.29729 13.2288C8.20825 13.152 8.13593 13.0575 8.08488 12.9511C8.03383 12.8448 8.00514 12.729 8.00061 12.611C7.99609 12.4929 8.01582 12.3752 8.05859 12.2652C8.10135 12.1553 8.16621 12.0554 8.24911 11.9719C8.332 11.8883 8.43113 11.823 8.54028 11.7799C8.64943 11.7368 8.76625 11.7169 8.88339 11.7215C9.00053 11.726 9.11547 11.7549 9.221 11.8064C9.32652 11.8578 9.42036 11.9307 9.49661 12.0204L10.9001 13.4345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCheckIcon);
export default __webpack_public_path__ + "static/media/review-check-icon.86bb93da4a9d3dc1b0622c471969b306.svg";
export { ForwardRef as ReactComponent };